/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_YogaInputs */

const en_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yoga`)
};

const es_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yoga`)
};

const fr_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yoga`)
};

const de_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yoga`)
};

const ja_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヨガ`)
};

const zh_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瑜伽`)
};

const ar_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يوغا`)
};

const id_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yoga`)
};

const it_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yoga`)
};

const ru_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Йога`)
};

const pt_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yoga`)
};

const ko_val_yoga = /** @type {(inputs: Val_YogaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요가`)
};

/**
* | output |
* | --- |
* | "Yoga" |
*
* @param {Val_YogaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_yoga = /** @type {((inputs?: Val_YogaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_YogaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_yoga(inputs)
	if (locale === "es") return es_val_yoga(inputs)
	if (locale === "fr") return fr_val_yoga(inputs)
	if (locale === "de") return de_val_yoga(inputs)
	if (locale === "ja") return ja_val_yoga(inputs)
	if (locale === "zh") return zh_val_yoga(inputs)
	if (locale === "ar") return ar_val_yoga(inputs)
	if (locale === "id") return id_val_yoga(inputs)
	if (locale === "it") return it_val_yoga(inputs)
	if (locale === "ru") return ru_val_yoga(inputs)
	if (locale === "pt") return pt_val_yoga(inputs)
	return ko_val_yoga(inputs)
});